import { Controller } from "stimulus";
import { debounce } from '../app';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["bg"]
  connect() {
    let logo_img = document.querySelector(".logo-img");
    let triggerUpdate = debounce(() => { Rails.fire(this.element, 'submit') }, 200);
    this.bgTarget.addEventListener('change', triggerUpdate)
    this.bgTarget.addEventListener('change', () => { logo_img.style.backgroundColor = this.bgTarget.value })
  }
}
